import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  loginCognitoUser,
  sendVerificationCodeForgotPassword,
  submitNewPasswordWithVerificationCode,
  signInConfirmation,
  apiGetUserByEmail,
  handleTOTPSetup,
  handleTOTPSetupVerification,
  handleUpdateMFAPreference,
  logoutCognitoUser,
  apiUpdateUserLastTimeLogin,
  apiCreateLoginHistory
} from "apis/UserApi";
import { ReactComponent as IconEnvelop } from "assets/icon_envelop.svg";
import { ReactComponent as IconLocked } from "assets/icon_locked.svg";
import { ReactComponent as IconResend } from "assets/icon_resend.svg";
import logoImage from "assets/logo_company_name.png";
import { getCurrentUser } from 'aws-amplify/auth';
import FanLoadingIcon from 'components/FanLoadingIcon';
import {
  DIALOG_ERROR_INVALID_CONFIRM_PASSWORD,
  DIALOG_ERROR_USE_SHORT_KEYWORD,
  TEXT_BUTTON_BACKWARD,
  TEXT_BUTTON_LOGIN,
  TEXT_BUTTON_SEND,
  TEXT_CONFIRM_NEW_PASSWORD,
  TEXT_ERROR_INCORRECT_PASSWORD,
  TEXT_ERROR_INCORRECT_TOTP,
  TEXT_ERROR_USER_NOT_CONFIRMED,
  TEXT_FORGOT_PASSWORD_INPUT_CODE,
  TEXT_FORGOT_PASSWORD_INSTRUCTION,
  TEXT_FORGOT_PASSWORD_LINK,
  TEXT_LOGIN_ID,
  TEXT_NEW_PASSWORD,
  TEXT_PASSWORD,
  TEXT_SAVE_LOGIN
} from 'constants/message';
import { useGeneralSetting } from 'context/GeneralSettingContext';
import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import { QRCodeSVG } from 'qrcode.react';

const propTypes = {};
const defaultProps = {};
const LoginPage = (props) => {
  /*** States and Variables ***/
  const {
    register, handleSubmit, watch
  } = useForm();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [autoLogin, setAutoLogin] = useState(localStorage.getItem('AUTO_LOGIN') === 'true');
  const [forgotPassword, setForgotPassword] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [showPasswordInput, setShowPasswordInput] = useState(false);
  const [countDown, setCountDown] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { generalSetting } = useGeneralSetting();
  const [loading, setLoading] = useState(false);
  // MFA
  const [qrcode, setQrcode] = useState('');
  const [confirmSigninStep, setConfirmSigninStep] = useState(false);
  const [confirmTOTPSetupStep, setConfirmTOTPSetupStep] = useState(false);

  /*** Processing ***/
  useEffect(() => {
    if (isCodeSent) {
      let seconds = 300;
      const countTime = setInterval(() => {
        if (seconds > 0) {
          --seconds;
          setCountDown(seconds)
        } else {
          setIsCodeSent(false)
          clearInterval(countTime);
        }
      }, 1000)
    }
  }, [isCodeSent])

  React.useEffect(() => {
    document.title = generalSetting?.appTitle || 'ひたちなか市カメラ監視システム';
  }, [generalSetting])

  React.useEffect(() => {
    const checkAutoLogin = async () => {
      try {
        const CONFIRM_TOTP_SETUP_STEP = localStorage.getItem('CONFIRM_TOTP_SETUP_STEP');
        if (CONFIRM_TOTP_SETUP_STEP === 'true') {
          await logoutCognitoUser();
          localStorage.setItem('CONFIRM_TOTP_SETUP_STEP', false);
        } else {
          await getCurrentUser();
          navigate('/');
        }
      } catch (error) { }
    }
    checkAutoLogin();
  }, [])
  /*** Sub Components ***/
  const renderLoginContent = () => {
    return <>
      <div className='login_page_input_container'>
        <IconEnvelop />
        <input
          type='text'
          className='login_page_input'
          placeholder={TEXT_LOGIN_ID}
          value={email}
          onKeyDown={onKeyDown}
          onChange={(e) => {
            setEmail(e.target.value)
          }} />
      </div>
      <div className='login_page_input_container'>
        <IconLocked />
        <input
          type="password"
          className='login_page_input'
          placeholder={TEXT_PASSWORD}
          value={password}
          onKeyDown={onKeyDown}
          onChange={(e) => {
            setPassword(e.target.value)
          }} />
      </div>
      {errorMessage && <div className='login_page_error'>{errorMessage}</div>}
      <div className='login_page_checkbox_container'>
        <div
          onClick={onButtonAutoLoginClick}
          className='login_page_checkbox'>
          {autoLogin && <FontAwesomeIcon icon={faCheck} />}
        </div>
        <label
          className='login_page_checkbox_text'
          onClick={onButtonAutoLoginClick}>
          {TEXT_SAVE_LOGIN}
        </label>
      </div>
      <button
        className='login_page_button_login'
        onClick={login}>
        {TEXT_BUTTON_LOGIN}
      </button>
      {/* <label
        onClick={() => { setErrorMessage(''); setForgotPassword(true) }}
        className='login_page_box_bottom_text'>
        {TEXT_FORGOT_PASSWORD_LINK}
      </label> */}

    </>
  }

  const renderConfirmStepContent = () => {
    return <form onSubmit={handleSubmit(handleTOTPVerification)} className='forgot_password_form'>
      {qrcode &&
        [<label className='login_page_label'>
          認証アプリでQRコードをスキャンしてください。
        </label>,
        <div className='login_page_qrcode_container'>
          <QRCodeSVG value={qrcode} />
        </div>
        ]}
      <label className='login_page_label'>
        認証アプリで生成されたコードを入力してください。
      </label>
      <div className='login_page_input_container'>
        <input
          type='text'
          autoComplete="noop"
          className='login_page_input'
          placeholder='コード'
          {...register('totpCode')}
        />
      </div>
      {errorMessage && <div className='login_page_error'>{errorMessage}</div>}
      <button
        className='login_page_button_login'>
        {TEXT_BUTTON_SEND}
      </button>
      <label
        onClick={async () => {
          if (confirmTOTPSetupStep) {
            await logoutCognitoUser();
            localStorage.setItem('CONFIRM_TOTP_SETUP_STEP', false);
          }
          setErrorMessage('');
          setConfirmSigninStep(false);
          setConfirmTOTPSetupStep(false);
          setQrcode('')
        }}
        className='login_page_box_bottom_text'>
        {TEXT_BUTTON_BACKWARD}
      </label>
    </form>
  }

  const renderResetPasswordContent = () => {
    return <form onSubmit={handleSubmit(handleForgotPassword)} className='forgot_password_form'>
      <label className='login_page_label'>
        {!showPasswordInput ? TEXT_FORGOT_PASSWORD_INSTRUCTION : TEXT_FORGOT_PASSWORD_INPUT_CODE}
      </label>
      <div className='login_page_input_container'>
        <IconEnvelop />
        <input
          type='text'
          autoComplete="noop"
          className='login_page_input'
          placeholder={TEXT_LOGIN_ID}
          {...register('email')}
        />
      </div>

      {showPasswordInput && <>
        <div className='login_page_input_container'>
          <input
            type='text'
            autoComplete="noop"
            className='login_page_input'
            placeholder='認証コード'
            {...register('code')}
          />
          {countDown || <IconResend className='pointer' onClick={sendVerificationCodeResetPassword} />}
        </div>
        <div className='login_page_input_container'>
          <input
            type='password'
            autoComplete="noop"
            className='login_page_input'
            placeholder={TEXT_NEW_PASSWORD}
            {...register('password')}
          />
        </div>
        <div className='login_page_input_container'>
          <input
            type='password'
            autoComplete="noop"
            className='login_page_input'
            placeholder={TEXT_CONFIRM_NEW_PASSWORD}
            {...register('confirm_password')}
          />
        </div>
      </>}
      {errorMessage && <div className='login_page_error'>{errorMessage}</div>}
      <button
        className='login_page_button_login'>
        {TEXT_BUTTON_SEND}
      </button>
      <label
        onClick={() => { setErrorMessage(''); setForgotPassword(false) }}
        className='login_page_box_bottom_text'>
        {TEXT_BUTTON_BACKWARD}
      </label>
    </form>
  }

  /*** Event Handlers ***/
  const onKeyDown = async (e) => {
    if (e.key === 'Enter') {
      await login();
    }
  }

  const errorHandle = (error) => {
    switch (error) {
      case 'User is not confirmed.':
        setErrorMessage(TEXT_ERROR_USER_NOT_CONFIRMED);
        break;
      case 'Code mismatch':
      case 'Invalid code received for user':
      case "1 validation error detected: Value at 'userCode' failed to satisfy constraint: Member must have length greater than or equal to 6":
      case "1 validation error detected: Value at 'userCode' failed to satisfy constraint: Member must have length less than or equal to 6":
        setErrorMessage(TEXT_ERROR_INCORRECT_TOTP);
        break;
      default:
        setErrorMessage(TEXT_ERROR_INCORRECT_PASSWORD);
        break;
    }
  }

  const login = async () => {
    setLoading(true);
    const response = await loginCognitoUser(email, password);
    if (response.success) {
      setErrorMessage('');
      const nextStep = response.data.nextStep;
      const appName = generalSetting?.appTitle || '冠水監視';
      switch (nextStep.signInStep) {
        case 'DONE':
          const user = await apiGetUserByEmail(email);
          if (user.enabledMFA) {
            localStorage.setItem('CONFIRM_TOTP_SETUP_STEP', true);
            const totpSetupDetails = await handleTOTPSetup(appName, email);
            if (totpSetupDetails.success) {
              setQrcode(totpSetupDetails.data);
              setConfirmTOTPSetupStep(true);
            } else {
              errorHandle(totpSetupDetails.error.message);
            }
          } else {
            await apiUpdateUserLastTimeLogin({
              id: user.id,
              data: JSON.stringify({
                ...user.data,
                lastTimeLogin: new Date().getTime()
              })
            });
            await apiCreateLoginHistory(user.id, true, null, navigator.userAgent);
            localStorage.setItem('LAST_ACCESS_LOGGED', new Date().getTime().toString());
            navigate('/');
            localStorage.setItem('LEAVE_TIME', new Date().getTime());
          }
          break;
        // case 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP':
        //   const totpSetupDetails = nextStep.totpSetupDetails;
        //   const setupUri = totpSetupDetails.getSetupUri(appName, email);
        //   setQrcode(setupUri);
        //   setConfirmSigninStep(true);
        //   break;
        case 'CONFIRM_SIGN_IN_WITH_TOTP_CODE':
          setConfirmSigninStep(true);
          break;
        default:
          break;
      }
    }
    else errorHandle(response.message);
    setLoading(false);
  }

  const sendVerificationCodeResetPassword = async () => {
    if (isCodeSent) return;
    setLoading(true);
    await sendVerificationCodeForgotPassword(watch('email'));
    setLoading(false);
    setIsCodeSent(true);
    setShowPasswordInput(true);
  }

  const handleForgotPassword = async (data) => {
    setLoading(true);
    if (!showPasswordInput) {
      await sendVerificationCodeResetPassword();
    }
    if (data.code) {
      if (data.password.length < 8) {
        setErrorMessage(DIALOG_ERROR_USE_SHORT_KEYWORD);
        setLoading(false);
        return;
      }
      else if (data.password !== data.confirm_password) {
        setErrorMessage(DIALOG_ERROR_INVALID_CONFIRM_PASSWORD);
        setLoading(false);
        return;
      }
      await submitNewPasswordWithVerificationCode(data.email, data.code, data.password);
      setForgotPassword(false);
      setErrorMessage('');
    }
    setLoading(false);
  }

  const handleTOTPVerification = async () => {
    setLoading(true);
    let response;
    if (confirmTOTPSetupStep) {
      response = await handleTOTPSetupVerification(watch('totpCode'));
      if (response.success) {
        await handleUpdateMFAPreference();
        localStorage.setItem('CONFIRM_TOTP_SETUP_STEP', false);
      }
    }
    if (confirmSigninStep) {
      response = await signInConfirmation(watch('totpCode'));
    }
    if (response.success) {
      const user = await apiGetUserByEmail(email);
      if (user) {
        await apiUpdateUserLastTimeLogin({
          id: user.id,
          data: JSON.stringify({
            ...user.data,
            lastTimeLogin: new Date().getTime()
          })
        });
        await apiCreateLoginHistory(user.id, true, null, navigator.userAgent);
        localStorage.setItem('LAST_ACCESS_LOGGED', new Date().getTime().toString());
      }
      navigate('/');
      localStorage.setItem('LEAVE_TIME', new Date().getTime());
    } else {
      errorHandle(response.error.message);
    }
    setLoading(false);
  }

  const onButtonAutoLoginClick = () => {
    localStorage.setItem('AUTO_LOGIN', !autoLogin);
    setAutoLogin(!autoLogin);
  }

  /*** Main Render ***/
  return <div className='login_page_container'>
    <div className='login_page_upper_background' />
    <div className='login_page_content_container'>
      <img
        className='login_page_logo'
        src={logoImage} alt='' />
      <div className='login_page_content_box'>
        <label className='login_page_box_title'>
          {generalSetting?.appTitle}
        </label>
        {forgotPassword ? renderResetPasswordContent() : (confirmSigninStep || confirmTOTPSetupStep) ? renderConfirmStepContent() : renderLoginContent()}
      </div>
    </div>
    {loading && <FanLoadingIcon size={80} />}
  </div>;
}
LoginPage.propTypes = propTypes;
LoginPage.defaultProps = defaultProps;
export default LoginPage;
